import React from "react";
import { Service } from "..";
import "./services.css";

function Services({ list }) {
  var services = list.map((intro, idx) => <Service {...intro} key={idx} />);
  // let intros = []
  // for (let intro of props.intros) {
  //     intros.push(<Intro props={intro} />)
  // }

  return <div className="services">{services}</div>;
}

export default Services;
